export class SourceTypeRequest {
    public candidateCustomDataVo : CandidateCustomDataVo = new CandidateCustomDataVo();
}

class CandidateCustomDataVo {
    
}


